<script lang="ts">
    import { onMount } from "svelte";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { networkStore } from "../../../../store/networks";
    import { user } from "../../../../store/stores";
    import NetworkCard from "./Components/NetworkCard.svelte";

    const getNetworks = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .networkClient.listNetworks({ size: 40 })
                .then((networks) =>
                    networkStore.update((networkStore) => {
                        return {
                            ...networkStore,
                            networks: networks,
                        };
                    })
                );
        });
    };

    onMount(() => getNetworks());
</script>

<div class="container">
    <div class="columns is-multiline">
        {#if $networkStore.networks && $networkStore.networks.entries}
            {#each $networkStore.networks.entries as network}
                <div class="column is-one-third">
                    <NetworkCard {network} clickable />
                </div>
            {/each}
        {/if}
    </div>
</div>

<style>
    .container {
        padding-top: 1rem;
    }
</style>
